import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-files-details-previewer',
  templateUrl: './files-details-previewer.component.html',
  styleUrls: ['./files-details-previewer.component.scss'],
})
export class FilesDetailsPreviewerComponent implements OnInit {
  @Input()
  private file: string;

  @Input()
  private type: string;
  constructor() {
  }

  ngOnInit() {
  }
}
